import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { BoldTailHeading } from '~/utils/boldTailHeading'
import './UspsDarkOverlay.css'

export default function UspsDarkOverlay({ section, index, className = '' }) {
  const { usps, textCard } = section
  const heading = textCard?.subheading || textCard?.heading?.text
  const subtext = textCard?.subheading
    ? (textCard?.content || textCard?.heading?.text)
    : textCard?.content

  return (
    <section id={section.fieldGroupName + index} className={`usps-dark-overlay ${className}`}>
      <div className="container">
        {(heading || subtext) && (
          <div className="usps-dark-overlay__header">
            {heading && (
              <h2 className="usps-dark-overlay__heading">
                <BoldTailHeading text={heading} />
              </h2>
            )}
            {subtext && <p className="usps-dark-overlay__subtext">{subtext}</p>}
          </div>
        )}
        <div className="usps-dark-overlay__grid">
          {usps.map((usp, i) => (
            <FadeInWhenVisible key={i} transition={{ delay: `${i * 0.05}` }}>
              <div>
                <div className="usps-dark-overlay__card-image-wrap">
                  {usp.image && (
                    <Image
                      data={usp.image}
                      objectFit="cover"
                    />
                  )}
                  {(usp.heading || usp.content) && (
                    <div className="usps-dark-overlay__card-text">
                      {usp.heading && <p className="usps-dark-overlay__card-heading">{usp.heading}</p>}
                      {usp.content && <p className="usps-dark-overlay__card-content">{usp.content}</p>}
                    </div>
                  )}
                </div>
              </div>
            </FadeInWhenVisible>
          ))}
        </div>
      </div>
    </section>
  )
}
